export const projects= [
    {
    title:"Food_Ordering_App",
    subtitle:"JavaScript,ReactJs,Redux",
    description:
    "Developed a dynamic, full-stack food ordering platform designed to enhance user engagement and performance.Integrated Swiggy APIs to provide real-time, accurate data. Increased user retention and implementing an intuitive and visually appealing design using Tailwind CSS, creating a fast and fluid interface for end users.",
    image : require("./images/swi.png"),
    link:"https://github.com/Srushtik942/namaste-react"

    },

    {
        title:"Netflix_Clone",
        subtitle:"JavaScript,ReactJs,Firebase",
        description:"Designed and developed a Netflix-like platform leveraging advanced web technologies,built using ReactJS and JavaScript, delivering a responsive, scalable UI,implemented Firebase Authentication,optimized state management with Redux, ensuring fast and seamless data flow.",
        image:require("./images/netflix.png"),
        link:"https://github.com/Srushtik942/netflix_clone",

    },

    {
        title:"Python Projects",
        subtitle:"Python, ML(Algorithm)",
        description:"The Face Recognition System is an advanced project utilizing Python and machine learning algorithms for identifying and verifying faces in real-time or from static images. This system is built to recognize human faces by leveraging various image processing techniques and machine learning models to detect, extract facial features.",
        image:require("./images/python_logo.png"),
        link:"https://github.com/Srushtik942/Python_Projects"
    },


    {
        title:"Twitter_Clone",
        subtitle:"Java, Postgresql",
        description:"The Twitter Clone Application is a web-based platform designed to mimic the core functionalities of Twitter, allowing users to create accounts, post tweets, follow other users, and engage in social interactions. Built with Java Spring MVC as the backend framework and styled using CSS, this application provides a streamlined user experience and robust functionality.",
        image:require("./images/tweet.png"),
        link:""
    },


];




